import { IonModal } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IBaseSelectionMobileModalProps } from './base-selection-mobile-modal-props.interface'
import './base-selection-mobile-modal.scss'
import { BaseButton } from 'components'

const BaseSelectionMobileModal: React.FC<IBaseSelectionMobileModalProps> = ({
  onConfirmFunction,
  onDismissFunction,
  isOpen,
  setIsOpen,
  children,
  extraclassName = '',
}) => {
  const { t } = useTranslation()

  function dismiss() {
    setIsOpen(false)
    if (onDismissFunction) onDismissFunction()
  }

  function clickConfirm() {
    setIsOpen(false)
    if (onConfirmFunction) onConfirmFunction()
  }

  return (
    <IonModal className={'edisu-mobile-modal ' + extraclassName} showBackdrop isOpen={isOpen} onIonModalDidDismiss={() => dismiss()}>
      <div className="modal-content">{children}</div>
      <div className="buttonContainer">
        <BaseButton onClickFunction={() => clickConfirm()} label={t('apply_selection')} />
      </div>
    </IonModal>
  )
}

export default BaseSelectionMobileModal
